export class NetworkEpgFilesUpload {
    fileName: string;
    networkFile: File;
 }